/**
 * A comment that asked the agent: which thread, on which file, and the
 * thread as it read when it was sent. The member sees it as one line in the
 * chat; the answer belongs in the thread.
 */

import type { TextPart } from "ai";

export interface CommentAskPart {
  path: string;
  threadId: string;
  /** What the thread is on: the quoted text, or a mark's description. */
  on: string;
  messages: { authorName: string; body: string }[];
}

export const convertCommentAsk = ({
  path,
  threadId,
  on,
  messages,
}: CommentAskPart): TextPart => ({
  type: "text",
  text: [
    `<comment_ask path="${path}" thread="${threadId}">`,
    `Someone asked you in a comment thread on ${path}. Answer in that thread with the comments tool (reply, with this path and thread id), and keep your chat reply to one line that says you answered there. Answering needs no task.`,
    `On: ${on}`,
    "Thread:",
    ...messages.map((m) => `- ${m.authorName}: ${m.body}`),
    "</comment_ask>",
  ].join("\n"),
});
